module.exports = __webpack_public_path__ + "static/img/table1.5e90907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/table1.png
// module id = Xo2y
// module chunks = 1